<template>
  <div class="header header-fix">
    <van-nav-bar
        safe-area-inset-top
        :title='this.$route.meta.title'
        @click-left="onClickLeft"
    >
      <template #left v-if="this.$route.meta.iconLeft">
        <van-icon name="arrow-left" style="font-size:24px" />
      </template>
    </van-nav-bar>
  </div>
</template>
<script>
export default {
  name:'',
  data(){
    return{
    }
  },
  methods:{
    onClickLeft(){
        this.$router.go(-1);
    },
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>
.header-fix{
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
}
</style>
